(function () {
  const header = document.querySelector('[data-misui-header]');
  if (!header) return;

  const dropdown = header.querySelector('[data-misui-dropdown]');
  const panels = header.querySelectorAll('[data-misui-panel]');
  const triggers = header.querySelectorAll('[data-misui-trigger]');
  const mobile = header.querySelector('[data-misui-mobile]');
  const openBtn = header.querySelector('[data-misui-open]');
  const closeBtn = header.querySelector('[data-misui-close]');
  const accordions = header.querySelectorAll('[data-misui-accordion]');

  // FIX: Mover el overlay móvil al <body> para escapar del contexto de
  // compositing del header. backdrop-filter en un ancestro rompe
  // position: fixed y la opacidad de los hijos en Safari y algunos Chrome.
  if (mobile) document.body.appendChild(mobile);

  // Scroll state — collapsed nav on scroll down (like the React version)
  let lastY = window.scrollY;
  let revealed = false;
  function onScroll() {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 40);
    if (y < 80) {
      header.classList.remove('is-compact');
      revealed = false;
    } else if (y > lastY + 4) {
      header.classList.add('is-compact');
      revealed = false;
    } else if (y < lastY - 4) {
      header.classList.remove('is-compact');
    }
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
// ── Toast (shared) ─────────────────────────────────────────────────
window.misuiToast = (function () {
  var container = null;

  function getContainer() {
    if (!container) {
      container = document.createElement('div');
      container.className = 'misui-toast-container';
      document.body.appendChild(container);
    }
    return container;
  }

  function show(message) {
    var el = document.createElement('div');
    el.className = 'misui-toast';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="20 6 9 17 4 12"/></svg>' +
      '<span>' + message + '</span>';

    getContainer().appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-visible'); });
    });

    setTimeout(function () {
      el.classList.remove('is-visible');
      el.addEventListener('transitionend', function () { el.remove(); }, { once: true });
    }, 2200);
  }

  return { show: show };
})();
  // Desktop dropdowns
  function openPanel(index) {
    panels.forEach(p => {
      const match = p.getAttribute('data-misui-panel') === String(index);
      p.hidden = !match;
    });
    triggers.forEach(t => {
      t.setAttribute('aria-expanded', t.getAttribute('data-misui-trigger') === String(index) ? 'true' : 'false');
    });
    dropdown.hidden = false;
    header.classList.add('is-open');
  }
  function closePanels() {
    panels.forEach(p => (p.hidden = true));
    triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    dropdown.hidden = true;
    header.classList.remove('is-open');
  }

  triggers.forEach(t => {
    t.addEventListener('mouseenter', () => openPanel(t.getAttribute('data-misui-trigger')));
    t.addEventListener('focus', () => openPanel(t.getAttribute('data-misui-trigger')));
  });
  header.addEventListener('mouseleave', () => {
    closePanels();
    if (header.classList.contains('is-compact')) revealed = false;
  });

  // Hamburger
  openBtn && openBtn.addEventListener('click', () => {
    if (window.innerWidth >= 1024 && header.classList.contains('is-compact') && !revealed) {
      revealed = true;
      header.classList.remove('is-compact');
      return;
    }
    mobile.hidden = false;
    // Doble RAF: garantiza que el browser pinta el elemento antes de
    // iniciar la transición CSS, evitando el flash sin fondo.
    requestAnimationFrame(() => requestAnimationFrame(() => mobile.classList.add('is-visible')));
    document.body.classList.add('misui-no-scroll');
  });

  closeBtn && closeBtn.addEventListener('click', () => {
    mobile.classList.remove('is-visible');
    document.body.classList.remove('misui-no-scroll');
    setTimeout(() => { mobile.hidden = true; }, 600);
    accordions.forEach(a => {
      a.setAttribute('aria-expanded', 'false');
      const sign = a.querySelector('.misui-header__mobile-sign');
      if (sign) sign.textContent = '+';
      const panel = mobile.querySelector('[data-misui-accordion-panel="' + a.getAttribute('data-misui-accordion') + '"]');
      if (panel) panel.hidden = true;
    });
  });

  // Mobile accordion — los panels ahora se buscan en `mobile` (que está en body)
  accordions.forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (e.target.closest('a')) return; // click en el texto → navega, no despliega
      const idx = btn.getAttribute('data-misui-accordion');
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      accordions.forEach(other => {
        other.setAttribute('aria-expanded', 'false');
        const sign = other.querySelector('.misui-header__mobile-sign');
        if (sign) sign.textContent = '+';
        const p = mobile.querySelector('[data-misui-accordion-panel="' + other.getAttribute('data-misui-accordion') + '"]');
        if (p) p.hidden = true;
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        const sign = btn.querySelector('.misui-header__mobile-sign');
        if (sign) sign.textContent = '−';
        const panel = mobile.querySelector('[data-misui-accordion-panel="' + idx + '"]');
        if (panel) panel.hidden = false;
      }
    });
  });

  // Cart count now handled by the cart drawer module below
})();
// ── Search drawer ──────────────────────────────────────────
const searchDrawer     = document.querySelector('[data-misui-search-drawer]');
const searchOverlay    = document.querySelector('[data-misui-search-overlay]');
const searchInput      = document.querySelector('[data-misui-search-input]');
const searchResults    = document.querySelector('[data-misui-search-results]');
const searchCategories = document.querySelector('[data-misui-search-categories]');

let searchTimer = null;

function showCategories() {
  if (searchCategories) searchCategories.hidden = false;
  if (searchResults) searchResults.innerHTML = '';
}

function hideCategories() {
  if (searchCategories) searchCategories.hidden = true;
}

function openSearchDrawer() {
  searchDrawer.hidden  = false;
  searchOverlay.hidden = false;
  document.body.classList.add('search-open');

  // Al abrir, si no hay texto en el input, mostramos las categorías sugeridas
  if (!searchInput.value.trim()) {
    showCategories();
  } else {
    hideCategories();
  }

  requestAnimationFrame(() => {
    searchOverlay.classList.add('is-visible');
    searchDrawer.classList.add('is-open');
    searchInput.focus();
  });
}

function closeSearchDrawer() {
  searchOverlay.classList.remove('is-visible');
  searchDrawer.classList.remove('is-open');
  document.body.classList.remove('search-open');

  searchDrawer.addEventListener('transitionend', () => {
    searchDrawer.hidden  = true;
    searchOverlay.hidden = true;
  }, { once: true });
}

// Abrir
document.querySelectorAll('[data-misui-search-open]').forEach(btn => {
  btn.addEventListener('click', openSearchDrawer);
});

// Cerrar
document.querySelectorAll('[data-misui-search-close]').forEach(btn => {
  btn.addEventListener('click', closeSearchDrawer);
});
searchOverlay.addEventListener('click', closeSearchDrawer);

// Escape
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && searchDrawer.classList.contains('is-open')) {
    closeSearchDrawer();
  }
});

// Búsqueda con la Predictive Search API de Shopify
searchInput.addEventListener('input', () => {
  clearTimeout(searchTimer);
  const q = searchInput.value.trim();

  if (q.length < 2) {
    searchResults.innerHTML = '';
    showCategories();
    return;
  }

  hideCategories();

  searchTimer = setTimeout(async () => {
    try {
      const res  = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title`
      );
      const data = await res.json();
      const products = data.resources?.results?.products ?? [];
      renderResults(products, q);
    } catch (err) {
      console.error('Search error:', err);
    }
  }, 280);
});

function renderResults(products, q) {
  if (!products.length) {
    searchResults.innerHTML = `<p class="misui-search__empty micro-label">Sin resultados para "${q}"</p>`;
    return;
  }

  searchResults.innerHTML = products.map(p => `
    <a href="${p.url}" class="misui-search__item">
      <div class="misui-search__thumb">
        ${p.image ? `<img src="${p.image}" alt="${p.title}" width="48" height="48" loading="lazy">` : ''}
      </div>
      <div class="misui-search__info">
        <span class="misui-search__title">${p.title}</span>
        <span class="misui-search__type micro-label">${p.product_type || ''}</span>
      </div>
    </a>
  `).join('');
}
// ── Cart drawer ──────────────────────────────────────────
(function () {
  const cartDrawer  = document.querySelector('[data-misui-cart-drawer]');
  const cartOverlay = document.querySelector('[data-misui-cart-overlay]');
  const cartBody     = document.querySelector('[data-misui-cart-body]');
  const cartFooter   = document.querySelector('[data-misui-cart-footer]');
  if (!cartDrawer || !cartOverlay || !cartBody) return;

  let currentCart = null;

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function formatMoney(cents, currency) {
    currency = currency || (currentCart && currentCart.currency) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateCartBadge(cart) {
    document.querySelectorAll('[data-misui-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-misui-cart-count-label]').forEach(el => { el.textContent = cart.item_count; });
  }

  function renderCartItems(cart) {
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="misui-cart__empty micro-label">Your cart is empty</div>';
      if (cartFooter) cartFooter.hidden = true;
      return;
    }
    if (cartFooter) cartFooter.hidden = false;

    cartBody.innerHTML = cart.items.map(item => {
      const atMax = typeof item.quantity !== 'undefined' && item.inventory_quantity !== undefined
        ? item.quantity >= item.inventory_quantity
        : false;
      const unitPrice = formatMoney(item.price, cart.currency);
      const linePrice = formatMoney(item.final_line_price, cart.currency);

      return `
      <div class="misui-cart__item" data-misui-cart-line="${item.key}">
        <a href="${item.url}" class="misui-cart__item-thumb">
          ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" width="80" height="80" loading="lazy">` : ''}
        </a>
        <div class="misui-cart__item-info">
          <a href="${item.url}" class="misui-cart__item-title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title ? `<span class="misui-cart__item-variant micro-label">${escapeHtml(item.variant_title)}</span>` : ''}
          <div class="misui-cart__item-qty">
            <button type="button" class="misui-cart__qty-btn" data-misui-cart-decrease="${item.key}" aria-label="Decrease quantity">−</button>
            <span class="misui-cart__qty-value">${item.quantity}</span>
            <button type="button" class="misui-cart__qty-btn" data-misui-cart-increase="${item.key}" aria-label="Increase quantity" ${atMax ? 'disabled' : ''}>+</button>
          </div>
          ${atMax ? `<span class="misui-cart__item-stock micro-label">Max stock reached</span>` : ''}
          <button type="button" class="misui-cart__item-remove micro-label" data-misui-cart-remove="${item.key}">Remove</button>
        </div>
        <div class="misui-cart__item-price">
          <div class="misui-cart__item-breakdown">${item.quantity} × ${unitPrice}</div>
          <div class="misui-cart__item-total">${linePrice}</div>
        </div>
      </div>
    `;
    }).join('');
  }

  function updateCartTotals(cart) {
    const subtotalEl = document.querySelector('[data-misui-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    currentCart = await res.json();
    return currentCart;
  }

  async function refreshCartUI() {
    const cart = await fetchCart();
    renderCartItems(cart);
    updateCartTotals(cart);
    updateCartBadge(cart);
    return cart;
  }

  async function updateLine(key, quantity) {
    if (cartRequestPending) return;
    cartRequestPending = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      if (cart.status) {
        // Shopify devolvió error (p.ej. stock insuficiente) — refrescamos con el cart real
        await refreshCartUI();
        return;
      }
      currentCart = cart;
      renderCartItems(cart);
      updateCartTotals(cart);
      updateCartBadge(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
    } catch (err) {
      console.error('Cart update error:', err);
    } finally {
      cartRequestPending = false;
    }
  }

  let cartRequestPending = false;

  function changeLineQuantity(key, delta) {
    if (cartRequestPending || !currentCart) return;
    const item = currentCart.items.find(i => String(i.key) === String(key));
    if (!item) return;

    let newQty = item.quantity + delta;
    if (delta > 0 && typeof item.inventory_quantity === 'number' && newQty > item.inventory_quantity) {
      newQty = item.inventory_quantity;
      if (newQty === item.quantity) return; // ya está al máximo
    }
    newQty = Math.max(0, newQty);
    updateLine(key, newQty);
  }

  cartBody.addEventListener('click', e => {
    const inc = e.target.closest('[data-misui-cart-increase]');
    const dec = e.target.closest('[data-misui-cart-decrease]');
    const rem = e.target.closest('[data-misui-cart-remove]');
    if (inc && !inc.disabled) changeLineQuantity(inc.getAttribute('data-misui-cart-increase'), 1);
    if (dec) changeLineQuantity(dec.getAttribute('data-misui-cart-decrease'), -1);
    if (rem) updateLine(rem.getAttribute('data-misui-cart-remove'), 0);
  });

  cartBody.addEventListener('click', e => {
    const inc = e.target.closest('[data-misui-cart-increase]');
    const dec = e.target.closest('[data-misui-cart-decrease]');
    const rem = e.target.closest('[data-misui-cart-remove]');
    if (inc) changeLineQuantity(inc.getAttribute('data-misui-cart-increase'), 1);
    if (dec) changeLineQuantity(dec.getAttribute('data-misui-cart-decrease'), -1);
    if (rem) updateLine(rem.getAttribute('data-misui-cart-remove'), 0);
  });

  function openCartDrawer() {
    cartDrawer.hidden = false;
    cartOverlay.hidden = false;
    document.body.classList.add('cart-open');
    requestAnimationFrame(() => {
      cartOverlay.classList.add('is-visible');
      cartDrawer.classList.add('is-open');
    });
    refreshCartUI();
  }

  function closeCartDrawer() {
    cartOverlay.classList.remove('is-visible');
    cartDrawer.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    cartDrawer.addEventListener('transitionend', () => {
      cartDrawer.hidden = true;
      cartOverlay.hidden = true;
    }, { once: true });
  }

  document.querySelectorAll('[data-misui-cart-open]').forEach(btn => btn.addEventListener('click', openCartDrawer));
  document.querySelectorAll('[data-misui-cart-close]').forEach(btn => btn.addEventListener('click', closeCartDrawer));
  cartOverlay.addEventListener('click', closeCartDrawer);

  const checkoutBtn = document.querySelector('[data-misui-cart-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', () => { window.location.href = '/checkout'; });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
  });

  // Open (and refresh) whenever an item is added elsewhere in the theme
  document.addEventListener('cart:updated', () => {
    if (!cartDrawer.classList.contains('is-open')) {
      openCartDrawer();
    } else {
      refreshCartUI();
    }
  });
})();

// ── Login drawer ──────────────────────────────────────────
(function () {
  const loginDrawer  = document.querySelector('[data-misui-login-drawer]');
  const loginOverlay = document.querySelector('[data-misui-login-overlay]');
  if (!loginDrawer || !loginOverlay) return;

  function openLoginDrawer() {
    loginDrawer.hidden  = false;
    loginOverlay.hidden = false;
    document.body.classList.add('login-open');

    requestAnimationFrame(() => {
      loginOverlay.classList.add('is-visible');
      loginDrawer.classList.add('is-open');
      const firstInput = loginDrawer.querySelector('input');
      if (firstInput) firstInput.focus();
    });
  }

  function closeLoginDrawer() {
    loginOverlay.classList.remove('is-visible');
    loginDrawer.classList.remove('is-open');
    document.body.classList.remove('login-open');

    loginDrawer.addEventListener('transitionend', () => {
      loginDrawer.hidden  = true;
      loginOverlay.hidden = true;
    }, { once: true });
  }

  document.querySelectorAll('[data-misui-login-open]').forEach(btn => {
    btn.addEventListener('click', openLoginDrawer);
  });
  document.querySelectorAll('[data-misui-login-close]').forEach(btn => {
    btn.addEventListener('click', closeLoginDrawer);
  });
  loginOverlay.addEventListener('click', closeLoginDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && loginDrawer.classList.contains('is-open')) {
      closeLoginDrawer();
    }
  });

  // Si el formulario de login de Shopify devuelve error, el drawer debe
  // abrirse automáticamente para mostrar el mensaje (Shopify recarga la
  // página con los errores del form).
  if (loginDrawer.querySelector('.misui-header__login-error')) {
    openLoginDrawer();
  }
})();
// ── Wishlist (shared store + drawer) ──────────────────────────────
window.misuiWishlist = (function () {
  var KEY = 'misui:wishlist';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveAll(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function has(handle) {
    return getAll().some(function (i) { return i.handle === handle; });
  }

  function add(item) {
    var items = getAll();
    if (items.some(function (i) { return i.handle === item.handle; })) return items;
    items.unshift(item);
    saveAll(items);
    return items;
  }

  function remove(handle) {
    var items = getAll().filter(function (i) { return i.handle !== handle; });
    saveAll(items);
    return items;
  }

  function toggle(item) {
    return has(item.handle) ? remove(item.handle) : add(item);
  }

  return { getAll: getAll, has: has, add: add, remove: remove, toggle: toggle };
})();

(function () {
  var wishlistDrawer  = document.querySelector('[data-misui-wishlist-drawer]');
  var wishlistOverlay = document.querySelector('[data-misui-wishlist-overlay]');
  var wishlistBody    = document.querySelector('[data-misui-wishlist-body]');
  if (!wishlistDrawer || !wishlistOverlay || !wishlistBody) return;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function updateBadge(items) {
    document.querySelectorAll('[data-misui-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-misui-wishlist-count-label]').forEach(function (el) {
      el.textContent = items.length;
    });
  }

  function renderItems(items) {
    if (!items.length) {
      wishlistBody.innerHTML = '<div class="misui-wishlist__empty micro-label">Your wishlist is empty</div>';
      return;
    }
    wishlistBody.innerHTML = items.map(function (item) {
      return (
        '<div class="misui-wishlist__item" data-misui-wishlist-line="' + escapeHtml(item.handle) + '">' +
          '<a href="' + item.url + '" class="misui-wishlist__item-thumb">' +
            (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy">' : '') +
          '</a>' +
          '<div class="misui-wishlist__item-info">' +
            '<a href="' + item.url + '" class="misui-wishlist__item-title">' + escapeHtml(item.title) + '</a>' +
            (item.price ? '<span class="misui-wishlist__item-price">' + escapeHtml(item.price) + '</span>' : '') +
            '<div class="misui-wishlist__item-actions">' +
              '<button type="button" class="misui-wishlist__item-add micro-label" data-misui-wishlist-add="' + escapeHtml(item.handle) + '" data-misui-wishlist-url="' + escapeHtml(item.url) + '">Add to cart</button>' +
              '<button type="button" class="misui-wishlist__item-remove micro-label" data-misui-wishlist-remove="' + escapeHtml(item.handle) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function refresh() {
    var items = window.misuiWishlist.getAll();
    renderItems(items);
    updateBadge(items);
    checkStockForItems(items);
  }

  function checkStockForItems(items) {
    items.forEach(function (item) {
      var btn = wishlistBody.querySelector('[data-misui-wishlist-add="' + CSS.escape(item.handle) + '"]');
      if (!btn) return;
      var productUrl = item.url || ('/products/' + item.handle);

      fetch(productUrl + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product) return;
          var hasStock = (product.variants || []).some(function (v) { return v.available; });
          if (!hasStock) {
            btn.classList.add('is-out-of-stock');
            btn.disabled = true;
            btn.textContent = 'Out of stock';
          }
        })
        .catch(function () { /* si falla la comprobación, se deja el botón activo y se valida en el click */ });
    });
  }

  async function addToCartFromWishlist(handle, btn) {
    if (!handle || btn.classList.contains('is-loading') || btn.classList.contains('is-out-of-stock') || btn.disabled) return;
    var originalText = btn.textContent;
    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      var productUrl = btn.getAttribute('data-misui-wishlist-url') || ('/products/' + handle);
      var res = await fetch(productUrl + '.js');
      if (!res.ok) throw new Error('Product fetch failed');
      var product = await res.json();
      var variant = (product.variants || []).find(function (v) { return v.available; });
      if (!variant) {
        btn.classList.add('is-out-of-stock');
        btn.classList.remove('is-loading');
        btn.textContent = 'Out of stock';
        if (window.misuiToast) window.misuiToast.show('Out of stock');
        return;
      }

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
      if (!addRes.ok) {
        var errData = await addRes.json().catch(function () { return {}; });
        throw new Error(errData.description || 'Could not add to cart');
      }

      btn.textContent = 'Added';
      if (window.misuiToast) window.misuiToast.show('Added to cart');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));

      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }, 1600);
    } catch (err) {
      console.error('Wishlist add-to-cart error:', err);
      btn.textContent = 'Unavailable';
      if (window.misuiToast) window.misuiToast.show('Could not add to cart');
      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }, 1800);
    }
  }

  wishlistBody.addEventListener('click', function (e) {
    var rem = e.target.closest('[data-misui-wishlist-remove]');
    if (rem) window.misuiWishlist.remove(rem.getAttribute('data-misui-wishlist-remove'));

    var add = e.target.closest('[data-misui-wishlist-add]');
    if (add) addToCartFromWishlist(add.getAttribute('data-misui-wishlist-add'), add);
  });

  document.addEventListener('wishlist:updated', refresh);

  function openWishlistDrawer() {
    wishlistDrawer.hidden = false;
    wishlistOverlay.hidden = false;
    document.body.classList.add('wishlist-open');
    requestAnimationFrame(function () {
      wishlistOverlay.classList.add('is-visible');
      wishlistDrawer.classList.add('is-open');
    });
    refresh();
  }

  function closeWishlistDrawer() {
    wishlistOverlay.classList.remove('is-visible');
    wishlistDrawer.classList.remove('is-open');
    document.body.classList.remove('wishlist-open');
    wishlistDrawer.addEventListener('transitionend', function () {
      wishlistDrawer.hidden = true;
      wishlistOverlay.hidden = true;
    }, { once: true });
  }

  document.querySelectorAll('[data-misui-wishlist-open]').forEach(function (btn) {
    btn.addEventListener('click', openWishlistDrawer);
  });
  document.querySelectorAll('[data-misui-wishlist-close]').forEach(function (btn) {
    btn.addEventListener('click', closeWishlistDrawer);
  });
  wishlistOverlay.addEventListener('click', closeWishlistDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wishlistDrawer.classList.contains('is-open')) closeWishlistDrawer();
  });

  updateBadge(window.misuiWishlist.getAll());
})();